var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4618_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 1.87695H10.1252V0.876953C10.1252 0.808203 10.069 0.751953 10.0002 0.751953H9.12525C9.05649 0.751953 9.00025 0.808203 9.00025 0.876953V1.87695H5.00024V0.876953C5.00024 0.808203 4.94399 0.751953 4.87524 0.751953H4.00024C3.93149 0.751953 3.87524 0.808203 3.87524 0.876953V1.87695H1.25024C0.973682 1.87695 0.750244 2.10039 0.750244 2.37695V12.752C0.750244 13.0285 0.973682 13.252 1.25024 13.252H12.7502C13.0268 13.252 13.2502 13.0285 13.2502 12.752V2.37695C13.2502 2.10039 13.0268 1.87695 12.7502 1.87695ZM12.1252 12.127H1.87524V6.18945H12.1252V12.127ZM1.87524 5.12695V3.00195H3.87524V3.75195C3.87524 3.8207 3.93149 3.87695 4.00024 3.87695H4.87524C4.94399 3.87695 5.00024 3.8207 5.00024 3.75195V3.00195H9.00025V3.75195C9.00025 3.8207 9.05649 3.87695 9.12525 3.87695H10.0002C10.069 3.87695 10.1252 3.8207 10.1252 3.75195V3.00195H12.1252V5.12695H1.87524Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4618_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.07a785c85fc0f73dfe00a9583893521d.svg";
export { ForwardRef as ReactComponent };